import Footer from "./Footer";
import Logo from "./Logo";
import PropTypes from "prop-types";
import useEnv from "../hooks/useEnv";
import { CUSTOMERTYPE } from "../contexts/AuthContext";

const LandingFooter = ({ locale, onSignIn }) => {
    const { isEnvTruthy } = useEnv();

    const signInButtonsElement = <>
        <button
            className="btn btn-personal-sign-in"
            onClick={() => onSignIn(CUSTOMERTYPE.PERSON)}
            aria-label={locale.personalSignInButton}
        >
            {locale.personalSignInButton}
        </button>
        {isEnvTruthy('COMPANY_TOGGLE') && (
            <button
                className="btn btn-company-sign-in"
                onClick={() => onSignIn(CUSTOMERTYPE.COMPANY)}
                aria-label={locale.companySignInButton}
            >
                {locale.companySignInButton}
            </button>
        )}
    </>

    return (
        <div className='landing-element-container' id="landing-page-footer">
            <div className='landing-element-content mb-5'>
                <div className='landing-page-footer-container'>
                    <h1>{locale.title}</h1>
                    <p>{locale.subtitle}</p>
                    <div className='flex-column gap-2 mt-4 d-flex mb-5'>
                        {signInButtonsElement}
                    </div>
                </div>
                <Logo color='rgba(255, 255, 255, 0.2)' width='100%' ariaLabel='MyRopo logo' />
            </div>
            <Footer landing />
        </div>
    )
}

LandingFooter.propTypes = {
    locale: PropTypes.object.isRequired,
    onSignIn: PropTypes.func.isRequired
}

export default LandingFooter;
